import { render, staticRenderFns } from "./quality-requirement.vue?vue&type=template&id=4a57911a&scoped=true"
import script from "./quality-requirement.vue?vue&type=script&lang=js"
export * from "./quality-requirement.vue?vue&type=script&lang=js"
import style0 from "./quality-requirement.vue?vue&type=style&index=0&id=4a57911a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a57911a",
  null
  
)

export default component.exports